<div class="form-row">
    <div class="form-group col-md-4">
      <label for="inputEmail4">Name</label>
      <input type="text" name='name' [(ngModel)]='this.calendar.name' [class.is-invalid]='!this.calendar.name' class="form-control" id="inputEmail4">
    </div>
    <div class="form-group col-md-4">
        <label for="inputEmail4">Colour</label>
        <input type="color" name='color' [(ngModel)]='this.calendar.colour' [class.is-invalid]='!this.calendar.colour' class="form-control" id="inputEmail4">
      </div>
</div>

<div class='form-row'>
    <div class='form-group col-md-12'>
        <label>Description</label>
        <textarea [(ngModel)]="this.calendar.description" class='form-control'></textarea>
    </div>
</div>